/* eslint-disable react/no-danger */
import React, { FC, useMemo, useState, useCallback, useRef, useEffect } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import Text from '../../atoms/Text';
import Constants from './Constants';
import { RateInfoDropdownProps } from './types';
import styles from './index.pcss';
import properties from '../../../modules/ajio-util/properties';
import RatingCard from '../../atoms/RatingCard';
import CustomerOpinion from '../../atoms/CustomerOpinion';
import { showModal } from '../../../actions/shared/modal';
import RateCalculationPopup from '../../organism/RateCalculationPopup';
import { getShowRateCalculate } from '../../selectors/featureFlagsSelector';
import ImageView from '../../atoms/ImageView';
import { getProperty } from '../../../modules/ajio-util/properties';

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config))
  };
};
const mapStateToProps = state => {
  const showRateCalculate = getShowRateCalculate(state?.flags);
  return {
    showRateCalculate
  };
};
const connector = connect(mapStateToProps, mapDispatchToProps);

const RateInfoDropdown: FC<RateInfoDropdownProps> = (props: RateInfoDropdownProps) => {
  const {
    title,
    asHtml,
    isUnderLineText,
    ctaOpenLabel,
    ctaCloseLabel,
    variant = 'default',
    luxe,
    isFleek,
    isPdpMoreInfo,
    ctaLocator,
    aggregateRating,
    subRatings,
    showModal,
    productCode,
    productName,
    productBrand,
    imageUrl,
    customerWords,
    isSignedIn,
    product_id,
    product_brick,
    showRateCalculate,
    toggleOn,
    productData={}
  } = props;
  let variantType = luxe ? 'luxeDefault' : variant;
  const cx = classNames.bind(styles);
  const [open, setOpen] = useState(false);
  const [showCalculatePopup, setShowCalculatePopup] = useState(false);
  const bodyRef = useRef(null);
  const moreInfo = open ? ctaOpenLabel : ctaCloseLabel;
  const dropMessage = moreInfo;
  const [showShareModal, setShowShareModal] = useState<boolean>(false);

  const onShareClose = useCallback(() => {
    document.body.style = null;
    setShowShareModal(false);
    setShowCalculatePopup(false);
  }, [setShowShareModal]);

  const bodyCls = cx('body-container', { hide: !open });

  const handleToggle = useCallback(() => {
    if (subRatings) {
      toggleOn();
      setOpen(!open);
      setShowCalculatePopup(false);
    }
  }, [setOpen, open]);

  const calculatePopup = () => {
    sessionStorage.setItem('exitIntent', 'true');
    setShowCalculatePopup(!showCalculatePopup);
    setShowShareModal(true);
  };
  const imageBaseUrl: string = properties.getProperty('imageBaseUrl');
  const starUrl = `${imageBaseUrl}/static/img/green_star_pdp.svg`;
  const ratingCalulation = `${imageBaseUrl}/static/img/rate_calculation.svg`;
  const { title: titleD, cta: ctaD } = Constants[variantType];
  const bodyDiv = useMemo(
    () => (
      <div ref={bodyRef} className={bodyCls}>
        {/* Ratin After more UI Start */}

        <RatingCard
          totalStarCount={aggregateRating?.numUserRatings}
          totalRatingCount={aggregateRating?.averageRating}
          isProgressBar
          image=""
          rateDesign=""
          rateData={aggregateRating || ''}
          calculatePopup={calculatePopup}
          isFleek={isFleek} 
          productData={productData}
        />
        {showRateCalculate && (
          <div
            className={cx('rating-calculation', isFleek ? 'fleek-rating-calculation' : '')}
            style={{ paddingBottom: '20px' }}
          >
            <span
              tabIndex={0}
              role="button"
              style={{ fontSize: '11px', float: 'right', display: 'flex', color: '#6d6d6d',padding: '4px 0px' }}
              aria-haspopup={'dialog'}
              onClick={calculatePopup}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // stops page scroll for Space
                  e.currentTarget.click();
                }
              }}

            >
              Rating Calculation
              {isFleek ? (
                <ImageView
                  src={`${getProperty(
                    'imageBaseUrl'
                  )}/static/img/fleek-pdp-ratings-information-icon.svg`}
                  alt="Information icon"
                  ariaHidden={true}
                  className={cx('fleek-rating-calculation-info-icon')}
                />
              ) : (
                <img
                  src={ratingCalulation}
                  alt="Information icon"
                  aria-hidden={true}
                  style={{ width: '15px', marginLeft: '5px' }}
                />
              )}
            </span>
          </div>
        )}
        {subRatings && (
          <CustomerOpinion
            subRating={subRatings ? subRatings : ''}
            titleD={titleD}
            productCode={productCode}
            productName={productName}
            product_id={productCode}
            product_brick={product_brick}
            aggregateRating={aggregateRating ? aggregateRating : ''}
            customerWords={customerWords}
            isFleek={isFleek}
          />
        )}
        {/* Ratin After more UI Start */}
      </div>
    ),
    [asHtml, bodyCls]
  );
  const rateProductModal = () => {
    showModal('rating-halfcard', {
      state: {
        deviceType: 'mobile',
        rating: '0',
        pageToDisplay: 'ratingHalfCard',
        displayFeedBackPage: true,
        isfromWriteFeedBack: true,
        isFeedBackSubmitted: true,
        isFromPDP: true,
        productDetails: {
          brandName: productBrand,
          description: productName,
          imageUrl,
          skuId: productCode,
          productCode,
          optionCode: productCode
        }
      }
    });
  };
  return (
    <>
      <div className={cx('title-container')} id={ctaLocator}>
        <div className={cx('title')}>
          <Text
            variant={titleD.textV}
            weight={titleD.weightV}
            color={isFleek ? 'White' : titleD.colorV}
            textTransform={luxe ? 'is-uppercase' : 'none'}
            role='heading'
            ariaLevel={3}
          >
            {title}
          </Text>
        </div>
        {/* <div className={cx('sr-only')}>
          {open ? "Minimize product rating" : "Click to view more product rating"}
        </div> */}
        {isPdpMoreInfo && subRatings && (
          <div 
            className={cx('cta', isUnderLineText ? 'underline' : '')}
            role="button"
            onClick={subRatings && handleToggle} 
            id={ctaLocator}
            aria-expanded={open ? "true" : "false"}
            tabIndex={0}
            aria-label={open ? "Minimize product rating" : "view more product rating"}
          >
            <Text
              textTransform={luxe ? 'is-uppercase' : 'none'}
              variant={ctaD.textV}
              weight={ctaD.weightV}
              color={isFleek ? 'Chartreuse_Yellow' : ctaD.colorV}
            >
              {dropMessage}
            </Text>
          </div>
        )}
      </div>

      {/* Ratin before more UI Start */}
      {!open && (
        <RatingCard
          totalRatingCount={aggregateRating?.averageRating}
          totalStarCount={aggregateRating?.numUserRatings}
          rateData={aggregateRating || ''}
          customerWords={customerWords}
          isProgressBar={!subRatings}
          calculatePopup={calculatePopup}
          isFleek={isFleek}
          productData={productData}
        />
      )}
      {showRateCalculate && !subRatings && (
        <div
          className={cx(
            'rating-calculation',
            'no-sub-rate',
            isFleek ? 'fleek-rating-calculation' : ''
          )}
        >
          <span
            tabIndex={0}
            role="button" onClick={calculatePopup}
            aria-haspopup={'dialog'}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault(); // stops page scroll for Space
                e.currentTarget.click();
              }
            }}
          >
            Rating Calculation <img src={ratingCalulation} alt="Information icon" aria-hidden={true}/>
          </span>
        </div>
      )}

      {/* Ratin before more UI Start */}
      {bodyDiv}
      {showCalculatePopup && (
        <RateCalculationPopup isDesktop={false} visible={showShareModal} onClose={onShareClose} />
      )}
    </>
  );
};

RateInfoDropdown.defaultProps = {
  asHtml: false,
  ctaOpenLabel: Constants.openText,
  ctaCloseLabel: Constants.closeText,
  variant: 'default',
  isUnderLineText: false
};

export default connector(RateInfoDropdown);
